import React from 'react';
import { useParams } from 'react-router';
import { useCast } from '../../../chromecast/hooks/use-cast';
import { ErrorBoundary } from '../../error-boundary';
import '../styles/ats-player.scss';
import { ChromecastVodSenderLoader } from './chromecast-vod-sender/chromecast-vod-sender-loader';
import { PlayerErrorFallback } from './player-error-fallback/player-error-fallback';
import { TrailerPlayerLoader } from './trailer-player/trailer-player-loader';

export function AtsTrailerPlayer() {
  const { platformTitleId, providerIdentifier } = useParams<{ platformTitleId: string; providerIdentifier: string }>();

  const cast = useCast();
  const castMediaPosition = cast.media !== undefined ? cast.media.getEstimatedTime() : undefined;

  if (cast.sessionStatus === 'connected' && cast.session !== undefined) {
    return (
      <ErrorBoundary fallback={(props) => <PlayerErrorFallback {...props} />}>
        <ChromecastVodSenderLoader
          session={cast.session}
          platformTitleId={platformTitleId}
          providerIdentifier={providerIdentifier}
          position={0}
          isTrailer={true}
        />
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary fallback={(props) => <PlayerErrorFallback {...props} />}>
      <TrailerPlayerLoader
        platformTitleId={platformTitleId}
        providerIdentifier={providerIdentifier}
        position={castMediaPosition}
      />
    </ErrorBoundary>
  );
}
